var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5286 15.2323L20.4547 19.1574L19.1576 20.4545L15.2324 16.5284C13.7719 17.6992 11.9553 18.336 10.0835 18.3333C5.5295 18.3333 1.8335 14.6373 1.8335 10.0833C1.8335 5.52934 5.5295 1.83334 10.0835 1.83334C14.6375 1.83334 18.3335 5.52934 18.3335 10.0833C18.3362 11.9552 17.6994 13.7718 16.5286 15.2323ZM14.6897 14.5521C15.8531 13.3557 16.5028 11.7521 16.5002 10.0833C16.5002 6.53768 13.6282 3.66668 10.0835 3.66668C6.53783 3.66668 3.66683 6.53768 3.66683 10.0833C3.66683 13.6281 6.53783 16.5 10.0835 16.5C11.7522 16.5026 13.3559 15.8529 14.5522 14.6896L14.6897 14.5521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImg);
export default __webpack_public_path__ + "static/media/searchImg.822cf5a5478f577ca88bcaf5c1f2d20b.svg";
export { ForwardRef as ReactComponent };